import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React from 'react';

import Fluid from 'components/Fluid';
import { ReactComponent as Chevron } from 'images/icons/chevron.svg';
import zparse from 'utils/zparse';

const AccordionList = ({ accordions = [], flush = false, hideTitle = false }) => {
	const [expandedItems, setExpandedItems] = React.useState({});
	const categories = accordions.filter(category => category?.accordions?.length);
	if (!categories.length) return null;

	return (
		<section className={`accordionList${flush ? ' accordionList--flush' : ''}`}>
			<Fluid layout="12" sx={{ rowGap: hideTitle ? "0px" : { sm: undefined, md: "80px" } }}>
				{categories.map((category, categoryIndex) => (
					<div className="accordionList__category" key={`${category?.name || 'category'}-${categoryIndex}`}>
						{!hideTitle && category?.name && (
							<Typography component="h3" variant="h2" className="accordionList__categoryTitle">{category.name}</Typography>
						)}
						<div className="accordionList__items">
							{category.accordions.map((accordion, accordionIndex) => {
								const contentId = `accordion-${categoryIndex}-${accordionIndex}`;
								return (
									<Accordion
										className="accordionList__item"
										key={`${accordion?.title || 'accordion'}-${accordionIndex}`}
										expanded={expandedItems[contentId] ?? !!accordion?.expanded}
										onChange={(_, isExpanded) => {
											setExpandedItems(previousItems => ({
												...previousItems,
												[contentId]: isExpanded,
											}));
										}}
										disableGutters
										elevation={0}
										square
									>
										<AccordionSummary
											className="accordionList__trigger"
											expandIcon={<Chevron className="accordionList__icon" aria-hidden="true" />}
											aria-controls={contentId}
											id={`${contentId}-header`}
										>
											<Typography component="h4" variant="h4">{accordion?.title}</Typography>
										</AccordionSummary>
										<AccordionDetails className="accordionList__content" id={contentId}>
											{zparse(accordion?.content || '')}
										</AccordionDetails>
									</Accordion>
								);
							})}
						</div>
					</div>
				))}
			</Fluid>
		</section>
	);
};

export default AccordionList;
